module.exports = __webpack_public_path__ + "img/2_cobe.6dbf7413.jpg";